import {ActionTree} from 'vuex';
import axios, { AxiosResponse } from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, CustomDetailFilterParams, CustomDetailItem, CustomDetailItemInfo, CustomGroupFilterParams, CustomGroupItem} from './types';

export const actions: ActionTree<StatisticState, RootState> = {

    async getCustomStatisticDetail({commit}, params: CustomDetailFilterParams): Promise<AxiosResponse> {
        commit('setLoading', true);
        try {
            const response: AxiosResponse<{messages: CustomDetailItem[]}> = await axios({url: '/stats-api/detail/custom', params: params});
            let messages = response.data?.messages ?? [];
            if (params.page_number > 1) {
                commit('pushCustomStatisticDetail', messages);
            } else {
                commit('setCustomStatisticDetail', messages);
            }
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },

    async getCustomStatisticDetailInfo({commit}, id: string): Promise<AxiosResponse> {
        commit('setLoading', true);
        try {
            const response: AxiosResponse<CustomDetailItemInfo> = await axios({url: `/stats-api/detail/custom/${encodeURIComponent(id)}`});
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },

    async exportCustomStatisticDetail({commit}, filter: CustomDetailFilterParams): Promise<AxiosResponse> {
        commit('setLoading', true);
        try {
            const response: AxiosResponse<{status: string}> = await axios({url: '/stats-api/detail/custom/export', params: filter});
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },

    resendCustomMessage: ({ commit, dispatch }, id: string) => {
        commit("setLoading", true);
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: '/acapi/tools/custom/resend',
                data: {message_ids: [id]}
            })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                })
                .finally(() => commit("setLoading", false));
        });
    },

    async getCustomStatisticGroup({commit}, filter: CustomGroupFilterParams): Promise<AxiosResponse> {
        commit('setLoading', true);
        try {
            const response: AxiosResponse<{messages_count: number, messages: CustomGroupItem[]}> = await axios({url: '/stats-api/group/custom', params: filter});
            commit('setCustomStatisticGroup', response.data.messages);
            commit('setCustomMessagesCount', response.data.messages_count);
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },

    async exportCustomStatisticGroup({commit}, filter: CustomGroupFilterParams): Promise<AxiosResponse> {
        commit('setLoading', true);
        try {
            const response: AxiosResponse<{status: string}> = await axios({url: 'stats-api/group/custom/export', params: filter});
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },

};
